import React, { useEffect } from "react";
//import { EventListView } from "./EventListView";
//import { HeadLine } from "../components/HeadLine";
import { PreCheckOut } from "../components/PreCheckOut"
import { EventInfo } from "../components/EventInfo";


export const EventsView = (props) => {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the window when the component mounts
  }, []); // Empty dependency array ensures the effect runs only once when the component mounts

  return (
     <>
      <div className="App">
          <div class="">
            <EventInfo />
        </div>
      </div>
    </>
  );
};
